export const TEMPLATE_FAMILIES = {
    INTERNAL: 'internal',
    CUSTOMER: 'customer',
    GUEST: 'guest',
    PUBLIC: 'public',
};

export const TEMPLATE_PROFILES = {
    ADMIN: 'admin',
    EMPLOYEE: 'employee',
    SERVICE_PROVIDER: 'service_provider',
    CUSTOMER: 'customer',
    GUEST: 'guest',
    PUBLIC: 'public',
};

export function normalizeTemplateValue(value, fallback = TEMPLATE_FAMILIES.PUBLIC) {
    const normalized = String(value || '').trim().toLowerCase();
    return normalized !== '' ? normalized : fallback;
}

export function deriveTemplateProfile({group = '', isAdmin = false, isServiceProvider = false, isEmployeeLike = false, isCustomer = false, isGuest = false} = {}) {
    if (isAdmin || group === TEMPLATE_PROFILES.ADMIN) {
        return TEMPLATE_PROFILES.ADMIN;
    }

    if (isServiceProvider || group === TEMPLATE_PROFILES.SERVICE_PROVIDER) {
        return TEMPLATE_PROFILES.SERVICE_PROVIDER;
    }

    if (isEmployeeLike || group === TEMPLATE_PROFILES.EMPLOYEE) {
        return TEMPLATE_PROFILES.EMPLOYEE;
    }

    if (isCustomer || group === TEMPLATE_PROFILES.CUSTOMER) {
        return TEMPLATE_PROFILES.CUSTOMER;
    }

    if (isGuest || group === TEMPLATE_PROFILES.GUEST) {
        return TEMPLATE_PROFILES.GUEST;
    }

    return TEMPLATE_PROFILES.PUBLIC;
}

export function deriveTemplateFamily({templateProfile = TEMPLATE_PROFILES.PUBLIC, workspaceAccess = false} = {}) {
    if ([TEMPLATE_PROFILES.ADMIN, TEMPLATE_PROFILES.EMPLOYEE, TEMPLATE_PROFILES.SERVICE_PROVIDER].includes(templateProfile)) {
        return TEMPLATE_FAMILIES.INTERNAL;
    }

    if (templateProfile === TEMPLATE_PROFILES.CUSTOMER) {
        return TEMPLATE_FAMILIES.CUSTOMER;
    }

    if (templateProfile === TEMPLATE_PROFILES.GUEST) {
        return TEMPLATE_FAMILIES.GUEST;
    }

    return workspaceAccess ? TEMPLATE_FAMILIES.INTERNAL : TEMPLATE_FAMILIES.PUBLIC;
}

export function defaultHomePathForTemplateFamily(templateFamily = TEMPLATE_FAMILIES.PUBLIC) {
    if (templateFamily === TEMPLATE_FAMILIES.CUSTOMER) {
        return '/dashboard';
    }

    if (templateFamily === TEMPLATE_FAMILIES.GUEST) {
        return '/workspace/tickets';
    }

    if (templateFamily === TEMPLATE_FAMILIES.INTERNAL) {
        return '/workspace/dashboard';
    }

    return '/auth/login';
}
